<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

  export default {
    components: {}
  }

</script>

<style lang="less">
  @import url('~@/assets/css/common.less');

  #app {

  }

  body {
    padding: 0;
    margin: 0;
  }
</style>